import { Route } from "react-router-dom";
import { StripePayment } from "features/payment";
import Document from "features/documents/pages/DocumentDetail";

import CheckEmailFuitesDonneesPage from "features/breaches/pages/RegistrationFuiteDonnees/CheckEmailFuitesDonneesPage";
import CreditsPricing from "features/credits/pages/CreditsPricing";
import Faq from "pages/Faq";
import FiligraneImporterPage from "features/filigrane/pages/FiligraneImporter/FiligraneImporterPage";
import Folder from "features/documents/pages/IDLockerDetail";
import FraudWizardPage from "features/fraud/pages/FraudFromUrlOrImage/FraudWizardPage";
import IDAssistantAdd from "features/accompaniment/pages/IDAssistantAdd";
import IDAssistantDetail from "features/accompaniment/pages/IDAssistantDetail";
import IDAssistantList from "features/accompaniment/pages/IDAssistantList";
import IDLockerFlow from "features/documents/pages/IDLocker/IDLockerFlow";
import IDLockerList from "features/documents/pages/IDLockerList";
import IDPayAdd from "features/idpay/pages/IDPay/IDPayAdd";
import IDPayDashboard from "features/idpay/pages/IDPay/IDPayDashboard";
import IDTracker from "features/breaches/pages/IDTracker";
import IDTrackerPricing from "features/breaches/pages/IDTrackerPricing";
import Layout from "components/Layout";
import ListIDs from "features/documents/pages/DocumentsList";
import NotificationAll from "features/notifications/pages/NotificationAll";
import PersonalData from "features/personal-data/pages/PersonalData/PersonalData";
import Profil from "features/account/pages/Profil";
import TestAI from "features/ai-assistant/pages/AI_Chat/TestAI";
import Verify from "features/analysis/pages/Verify";
export const individualRoutesOpen = (
    <>
      <Route
        path="/particuliers/faq"
        element={
          <Layout>
            <Faq />
          </Layout>
        }
      />
      <Route
        path="/particuliers/filter"
        element={
          <Layout>
            <FiligraneImporterPage />
          </Layout>
        }
      />
    </>
  );
export const individualRoutesProtected = (
    <>
      {(process.env?.REACT_APP_FOR_PARTNER_ONLY ?? "0") === "0" && (
        <>
          <Route
            path="/particuliers/dashboard"
            element={
              <Layout>
                {/*<Dashboard />*/}
                <ListIDs />
              </Layout>
            }
          />
          <Route
            path="/particuliers/id-locker/creer_dossier"
            element={
              <Layout>
                <IDLockerFlow/>
              </Layout>
            }
          />

          <Route
            path="/particuliers/personal-data/creer"
            element={
              <Layout>
                <PersonalData/>
              </Layout>
            }
          />


          <Route
            path="/particuliers/pieces-identite"
            element={
              <Layout>
                <ListIDs />
              </Layout>
            }
          />


          <Route
            path="/particuliers/fraud/leboncoin"
            element={
              <Layout>
                <FraudWizardPage />
              </Layout>
            }
          />

          <Route
            path="/mes-documents/:id"
            element={
              <Layout>
                <Document />
              </Layout>
            }
          />
          <Route
            path="/particuliers/id-assistant"
            element={
              <Layout>
                <IDAssistantList />
              </Layout>
            }
          />
          <Route
            path="/particuliers/id-assistant/add/:offreId"
            element={
              <Layout>
                <IDAssistantAdd />
              </Layout>
            }
          />
          <Route
            path="/particuliers/id-assistant/:id"
            element={
              <Layout>
                <IDAssistantDetail />
              </Layout>
            }
          />
          <Route
            path="/particuliers/id-locker/:id"
            element={
              <Layout>
                <Folder />
              </Layout>
            }
          />
          <Route
            path="/particuliers/id-locker/"
            element={
              <Layout>
                <IDLockerList />
              </Layout>
            }
          />
          <Route
            path="/particuliers/id-assistant/add/"
            element={
              <Layout>
                <IDAssistantAdd />
              </Layout>
            }
          />
          <Route
            path="/particuliers/idtracker"
            element={
              <Layout>
                <IDTracker />
              </Layout>
            }
          />

          <Route
            path="/particuliers/profil"
            element={
              <Layout>
                <Profil />
              </Layout>
            }
          />
          <Route
            path="/particuliers/verifier-document"
            element={
              <Layout>
                <Verify />
              </Layout>
            }
          />
          {/*<Route
                path="/particuliers/dark-web"
                element={
                    <Layout>
                        <Verify isDarkWeb />
                    </Layout>
                }
            />*/}
          <Route
            path="particuliers/id-assistant-ai"
            element={

              <Layout>
                <TestAI />
              </Layout>

            }
          />

          <Route
            path="/particuliers/credits-pricing"
            element={
              <Layout>
                <CreditsPricing />
              </Layout>
            }
          />
          <Route
            path="/particuliers/id-tracker-pricing"
            element={
              <Layout>
                <IDTrackerPricing />
              </Layout>
            }
          />
          <Route
            path="/particuliers/payment/:offer/:planIndex/:isMonth"
            element={
              <Layout>
                <StripePayment />
              </Layout>
            }
          />
          <Route
            path="/particuliers/id-pay/dashboard"
            element={
              <Layout>
                <IDPayDashboard />
              </Layout>
            }
          />
          <Route
            path="/particuliers/id-pay/add/"
            element={
              <Layout>
                <IDPayAdd />
              </Layout>
            }
          />

          <Route
            path="/particuliers/notifications"
            element={
              <Layout>
                <NotificationAll />
              </Layout>
            }
          />
          <Route
            path="/particuliers/fuites-donnees"
            element={
              <Layout>
                <CheckEmailFuitesDonneesPage />
              </Layout>
            }
          />
        </>
      )}
    </>
  );
